<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		[isExportable]="isExportable"
	></app-nav-gestion-donnees>

	<div class="row my-3">
		<div class="row">
			<div class="col-2 ms-lg-auto">
				<!-- <div class="dropdown" *ngIf="true">
					<a
						class="btn btn-secondary dropdown-toggle"
						profile="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtres
					</a>
				</div> -->
			</div>

			<div class="col-lg-4 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Libellé"
						[(ngModel)]="searchedInput"
						(keyup)="onKeyUp()"
					/>
				</div>
			</div>
		</div>
		<div *ngIf="!isMobile" class="row mt-3">
			<div class="col-2">
				<span class="hand-cursor fw-bold" (click)="sortChange('name')"
					>Libellé
					<span
						*ngIf="sortType === 'name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-9">
				<span class="hand-cursor fw-bold" (click)="sortChange('description')"
					>Description
					<span
						*ngIf="sortType === 'description' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'description' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-1">
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let role of roles
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage,
									totalItems: totalItems
							  }
						| orderBy : sortType : sortOrder
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-lg-2 col-12">
					<span *ngIf="isMobile" class="fw-bold">Libellé :</span>
					{{ role?.name}}
				</span>
				<span class="col-lg-9 col-12">
					<span *ngIf="isMobile" class="fw-bold">Description :</span>
					{{ role?.description}}
				</span>
				<span class="col-lg-1 col-12">
					<i
							[routerLink]="['/gestion/roles', role.id]"
							profile="button"
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
					></i>
				</span>
			</div>
		</div>
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="pageHasChanged($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
		</div>
	</div>
</div>
